module.exports = __webpack_public_path__ + "static/media/config.2dd2ca31.svg";